var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.r_is_first ? _c("div", { staticClass: "modal-mask" }) : _vm._e(),
    _vm._v(" "),
    _c("div", { class: { "modal-mask": !_vm.r_is_first } }, [
      _c(
        "div",
        {
          staticClass: "modal-mask-content",
          class: _vm.modal_mask_content_number
        },
        [
          _c("div", { staticClass: "modal-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "modal-container more-detail",
                class: _vm.container_class,
                attrs: { id: _vm.m_dragID }
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", { staticClass: "image-title" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-title" }, [
                    _c(
                      "div",
                      { staticClass: "title-area" },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.r_title) + " ")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.arr_sub_title, function(sub) {
                          return _c(
                            "span",
                            { staticClass: "subtitle" },
                            [
                              _c("font", { staticClass: "text-accent1" }, [
                                _vm._v(_vm._s(sub))
                              ])
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sub-title" },
                    [_vm._t("subtitle")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "close-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn-close",
                        attrs: { type: "button", if: "r_enable_cancel" },
                        on: { click: _vm.onBtnCancel }
                      },
                      [_c("i", { staticClass: "fa-solid fa-xmark" })]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "scroll-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "body-container",
                      attrs: { tabIndex: "-1" }
                    },
                    [_vm._t("content")],
                    2
                  )
                ])
              ]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0784134", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0784134","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/frameDialog.vue
// module id = 539
// module chunks = 0 1 2